import React from 'react';
import Ellipse74 from '../../Assets/Images/ellipse_74.svg';
import Ellipse75 from '../../Assets/Images/ellipse_75.svg';

const NoPermission = () => {
  return (
    <div
      style={{ backgroundColor: '#EAF2E5', maxHeight: 'calc(100vh - 64px)', overflow: 'hidden', position: 'relative' }}
    >
      <div style={{ maxWidth: '100%', height: '100%', position: 'absolute', right: 0 }}>
        <img src={Ellipse74} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'calc(100vh - 64px)',
          zIndex: 10
        }}
      >
        <div style={{ width: '90%', maxWidth: '494px', textAlign: 'center', marginTop: '30px', fontSize: '28px' }}>
          <p>There is no permission for this user, Please contact your administrator</p>
        </div>
      </div>
      <div style={{ width: '100%', height: 'auto', position: 'absolute', bottom: 0 }}>
        <img src={Ellipse75} />
      </div>
    </div>
  );
};

export default NoPermission;
